import React from 'react';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';

export interface UseSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit?: (value: string) => void;
  onClear?: () => void;
  placeholder?: string;
}

export const useSearchBar = ({
  value,
  onChange,
  onSubmit,
  onClear,
  placeholder,
}: UseSearchBarProps) => {
  const { translation } = useTranslationContext();
  const resolvedPlaceholder = placeholder ?? translation('search_bar_copy');

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSubmit?.(value);
    }
  };

  const handleClear = () => {
    if (onClear) {
      onClear();
    } else {
      onChange('');
    }
  };

  return { resolvedPlaceholder, handleKeyDown, handleClear };
};
